module.exports = __webpack_public_path__ + "img/VP-Classic-Profiles.443db2c0.jpg";